import { render } from "./HeartComponent.vue?vue&type=template&id=8b626568"
import script from "./HeartComponent.vue?vue&type=script&lang=js"
export * from "./HeartComponent.vue?vue&type=script&lang=js"

import "./HeartComponent.vue?vue&type=style&index=0&id=8b626568&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__